export const pointsCovertionRate = 0.033

export const installments = 6
